<script lang="ts">import { cfgCdnTiles, FeatureSet, stateFeatureSet, stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { isMobile, providerBasePath, toCamelCase, toSiteUrl } from "@infinitro/global";
import { InfoCard } from "@infinitro/info-card";
import { Text } from "@infinitro/text";
import { get } from "svelte/store";
import { getProviderLogoInlineStyle } from "./provider-logo-overrides";
let { item, fixedSize = false } = $props();
const stagePath = get(stateFeatureSet) === FeatureSet.Preview ? "/staging" : "";
let imageError = $state(false);
const CDN_TILES = cfgCdnTiles();
let useAlternative2 = $derived($stateUi.provider.providerStyle === "alternative2");
let useAlternative4 = $derived($stateUi.provider.providerStyle === "alternative4");
let useDefault = $derived($stateUi.provider.providerStyle === "default");
let useFlatNeutral = $derived($stateUi.provider?.useFlatNeutralCard ?? false);
let providerLogoStyle = $derived(getProviderLogoInlineStyle(item.prov));
</script>

<div class="item-card" class:fixed-size={fixedSize}>
	{#if useAlternative2}
		<div class="provider-card-content-alternative2">
			<!-- eslint-disable svelte/no-navigation-without-resolve -- toSiteUrl builds site-relative provider paths -->
			<a
				id={toCamelCase(item.prov)}
				class="provider"
				href={toSiteUrl(`${providerBasePath(item.prov)}${item.prov}`)}
			>
				<div
					class="provider-card"
					class:fixed-size={fixedSize}
					class:provider-card-alternative2={useAlternative2}
				>
					<div class="provider-icon-container">
						{#if !imageError}
							<img
								src={`${CDN_TILES}${stagePath}/t/${item.prov}.svg`}
								alt={item.name}
								class="provider-icon"
								style={providerLogoStyle}
								onerror={() => (imageError = true)}
							/>
						{:else}
							<Text
								textColor="white"
								type="body"
								bodyWeight="black"
								textAlign="center"
								customStyle="{$isMobile
									? 'font-size: 0.8rem;'
									: 'font-size: 1rem;'} padding-left: 1rem; padding-right: 1rem;"
							>
								{item.name}
							</Text>
						{/if}
					</div>
				</div>
			</a>
			<!-- eslint-enable svelte/no-navigation-without-resolve -->
			{#if item.count && item.count > 0}
				<div class="badge badge-alternative2">
					<div class="badge-alternative2-content">
						{item.count}
						{$t(Verbiage.games)}
					</div>
				</div>
			{/if}
		</div>
	{:else}
		<InfoCard width="100%" height="100%" withoutBorder noPadding>
			<!-- eslint-disable svelte/no-navigation-without-resolve -- toSiteUrl builds site-relative provider paths -->
			<a
				id={toCamelCase(item.prov)}
				class="provider"
				href={toSiteUrl(`${providerBasePath(item.prov)}${item.prov}`)}
			>
				<div
					class="provider-card {fixedSize ? 'fixed-size' : ''}"
					class:provider-card-useAlternative4={useAlternative4}
					class:provider-card-flat-neutral={useFlatNeutral}
				>
					{#if useDefault}
						<img
							src={`${CDN_TILES}${stagePath}/t/${item.prov}.svg`}
							alt={item.name}
							class="provider-icon-bg-top"
						/>
					{/if}

					<div class="provider-icon-container">
						{#if !imageError}
							<img
								src={`${CDN_TILES}${stagePath}/t/${item.prov}.svg`}
								alt={item.name}
								class="provider-icon"
								style={providerLogoStyle}
								onerror={() => (imageError = true)}
							/>
						{:else}
							<Text
								textColor="white"
								type="body"
								bodyWeight="black"
								textAlign="center"
								customStyle="{$isMobile
									? 'font-size: 0.8rem;'
									: 'font-size: 1rem;'} padding-left: 1rem; padding-right: 1rem;"
							>
								{item.name}
							</Text>
						{/if}
					</div>

					{#if useDefault}
						<img
							src={`${CDN_TILES}${stagePath}/t/${item.prov}.svg`}
							alt={item.name}
							class="provider-icon-bg-bottom"
						/>
					{/if}
				</div>
			</a>
			<!-- eslint-enable svelte/no-navigation-without-resolve -->
		</InfoCard>
	{/if}

	{#if !(useAlternative2 || useAlternative4) && item.count && item.count > 0}
		<div
			class="badge"
			class:badge--solid-primary={$stateUi.provider?.useSolidPrimaryGameCountBadge}
			class:badge-flat-neutral={useFlatNeutral}
		>
			{item.count}
			{$t(Verbiage.games)}
		</div>
	{/if}
</div>

<style>
	.provider-card {
		position: relative;
		display: flex;
		height: 100%;
		max-height: 105px;
		min-height: 63px;
		width: 100%;
		min-width: 150px;
		max-width: 250px;
		align-items: center;
		justify-content: center;
		aspect-ratio: 177 / 75;
}

	.provider-card-useAlternative4 {
		background-color: var(--color-tertiary-900);
}

	.provider-card.provider-card-flat-neutral {
		background-color: var(--color-highlight-2);
}

	.provider-card.fixed-size {
		height: 75px;
		width: 177px;
}

	.provider-card.provider-card-alternative2 {
		max-height: none;
		border-width: 1px;
		border-color: var(--color-primary-500);
		--tw-backdrop-blur: blur(10px);
		backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
		border-radius: 12px;
		background: radial-gradient(
			100% 200% at 0% 50%,
			var(--color-tertiary-100) 0%,
			transparent 100%
		);
		box-shadow:
			inset 0px -2px 8px 2px rgba(var(--color-primary-500-rgb) / 0.8),
			inset 1px 5px 7px 0px rgba(255, 255, 255, 0.1);
		aspect-ratio: 233 / 93;
}

	.provider-card.provider-card-alternative2.fixed-size {
		height: auto;
		width: 177px;
}

	.provider-icon-container {
		position: relative;
		display: flex;
		height: 100%;
		width: 100%;
		align-items: center;
		justify-content: center;
}

	.provider-card-content-alternative2 {
		position: relative;
		border-radius: 12px;
}

	.provider-icon {
		z-index: 10;
		max-height: 52px;
		max-width: 124px;
		cursor: pointer;
		-o-object-fit: contain;
		   object-fit: contain;
		image-rendering: auto;
		transform: translateZ(0);
		backface-visibility: hidden;
}

	.provider-card-content-alternative2 .provider-icon {
		height: 35px;
		width: auto;
		max-width: 80%;
}

	.provider-icon-bg-top {
		position: absolute;
		top: -40%;
		left: 0px;
		height: auto;
		width: 100%;
		-o-object-fit: cover;
		   object-fit: cover;
		opacity: 0;
}

	.provider-icon-bg-bottom {
		position: absolute;
		bottom: -40%;
		left: 0px;
		height: auto;
		width: 100%;
		-o-object-fit: cover;
		   object-fit: cover;
		opacity: 0;
}

	.badge {
		position: absolute;
		bottom: -9px;
		left: 50%;
		z-index: 40;
		--tw-translate-x: -50%;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
		white-space: nowrap;
		border-radius: 0.5rem;
		padding: 0.125rem;
		padding-left: 0.375rem;
		padding-right: 0.375rem;
		font-size: 0.5rem;
		font-weight: 700;
		--tw-text-opacity: 1;
		color: rgb(0 0 0 / var(--tw-text-opacity, 1));
		background: var(--gradient-secondary-light);
}

	@media (min-width: 1024px) {

		.badge {
				font-size: 0.6rem;
		}
}

	.badge {
		will-change: transform;
		transform: translate3d(-48%, 0, 0);
		backface-visibility: hidden;
		pointer-events: none;
		z-index: 9999;
	}

	.badge-alternative2 {
		background: none;
		bottom: -10px;
		height: 20px;
		width: 45%;
		border-radius: 4px;
		background-color: var(--color-primary-500);
		padding: 0px;
		--tw-shadow: 0 0 #0000;
		--tw-shadow-colored: 0 0 #0000;
		box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
		overflow: hidden;
	}

	.badge-alternative2-content {
		display: flex;
		height: 20px;
		align-items: center;
		justify-content: center;
		white-space: nowrap;
		font-size: 10px;
		font-weight: 600;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

	.badge--solid-primary {
		background-color: var(--color-primary-500);
		padding-top: 0px;
		padding-bottom: 0px;
		font-size: 12px;
		font-weight: 400;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));

		background-image: unset;
}

	.badge--solid-primary.badge-flat-neutral {
		font-weight: 600;
		color: var(--color-text-900);
}

	.item-card {
		position: relative;
		display: inline-block;
		height: 100%;
		max-height: 105px;
		min-height: 63px;
		width: 100%;
		min-width: 150px;
		max-width: 250px;
		flex-grow: 0;
		aspect-ratio: 177 / 75;
}

	.item-card.fixed-size {
		height: 75px;
		width: 177px;
}
</style>
